<template>
  <button
    v-show="!currentIsPlaying"
    class="flex w-[200px] items-center justify-center rounded-xl bg-white-100 p-4 text-base font-medium text-new-red-dark"
    @click.prevent="handleListenAudio"
  >
    <SvgIcon
      :name="isPlayed ? 'pause-icon' : 'play-icon'"
      class="mr-2 size-5"
    />
    Слушать
  </button>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['on-play']);

const audioStore = useAudioStore();
const toast = useToast();

// const isPlayAudio = ref(false);
const audioError = ref(false);

const currentIsPlaying = computed(() => {
  return audioStore.getData?.id === props.data?.id;
});

const playStoreAudio = computed(() => {
  return audioStore.getSrc;
});

const playThisAudio = computed(() => {
  if (!playStoreAudio.value || !props.data.path) return;
  return playStoreAudio.value?.includes(props.data?.path);
});

const isPlayed = computed(() => {
  return audioStore.isPlayed && playThisAudio.value;
});

const playAudio = async () => {
  pauseAudio();
  const audio = await new Audio(`${useHostApp()}${props.data.path}`);
  audio.preload = 'metadata';

  audio.addEventListener('error', () => {
    audioError.value = true;
    toast.error('При загрузке аудиофайла произошла ошибка, попробуйте позже!');
  });

  audio.addEventListener('loadedmetadata', () => {
    if (
      audio.readyState > 1 ||
      (!isNaN(audio.duration) && audio.duration > 1)
    ) {
      audioStore.start({
        audio,
        data: props.data,
      });

      audioStore.showFixedAudioBar();
      audioStore.setCurrentAudioData(props.data);
      audioStore.setCurrent(props.data);
      emit('on-play');
    }
  });
};

const pauseAudio = () => {
  audioStore.pause();
};

const setAudioSource = () => {
  if (audioError.value) {
    return;
  }
  playAudio();
};

const handleListenAudio = () => {
  if (props.data?.outer_link) {
    window.open(props.data?.outer_link, '_blank');
    return;
  }
  isPlayed.value ? pauseAudio() : setAudioSource();
};
</script>
